import * as THREE from 'three'

import Cursor from './Cursor'
import Grid from './Grid'

export default class SimpleGridExperience {
    /**
     * Constructor
     */
    constructor() {
        this.setTime()
        this.setSizes()
        this.setCursor()
        this.setRenderer()
        this.setGrid()

        this.update()
        this.resize()
    }

    /**
     * Set time
     */
    setTime() {
        this.time = {}
        this.time.start = +new Date()
        this.time.elapsed = 0
        this.time.current = this.time.start
        this.time.delta = 16
    }

    /**
     * Set cursor
     */
    setCursor() {
        this.cursor = new Cursor()
    }

    /**
     * Set resize
     */
    setSizes() {
        this.sizes = {}
        this.sizes.width = 1920
        this.sizes.height = 1080

        window.addEventListener('resize', () => {
            this.resize()
        })
    }

    /**
     * Set renderer
     */
    setRenderer() {
        // Renderer
        this.renderer = new THREE.WebGLRenderer({
            stencil: false,
            depth: true
        })
        this.renderer.setClearColor(0x000000)
        // this.renderer.sortObjects = false
    }

    setGrid() {
        this.grid = new Grid({
            time: this.time,
            sizes: this.sizes,
            cursor: this.cursor,
            renderer: this.renderer,
            hasTexture: false
        })
    }

    /**
     * Resize
     */
    resize() {
        this.sizes.width = window.innerWidth
        this.sizes.height = window.innerHeight

        // Resize cursor
        this.cursor.resize(this.sizes.width, this.sizes.height)

        // Resize scan
        this.grid.resize()

        // Renderer / Composer
        this.renderer.setSize(this.sizes.width, this.sizes.height)
    }

    /**
     * Update
     */
    update() {
        this.raf = window.requestAnimationFrame(() => {
            this.update()
        })

        const time = +new Date()
        this.time.elapsed = time - this.time.start
        this.time.delta = time - this.time.current
        this.time.current = time

        if (this.time.delta > 60) {
            this.time.delta = 60
        }

        // Update grid
        this.grid.update()
    }

    dispose() {
        // RAF
        window.cancelAnimationFrame(this.raf)

        // Resize
        window.removeEventListener('resize', this.resize)

        // Cursor
        this.cursor.dispose()

        // Grid
        this.grid.dispose()

        // Renderer
        this.renderer.dispose()
    }
}



// WEBPACK FOOTER //
// ./src/scripts/libs/experience/SimpleGridExperience.js